import { createSlice } from '@reduxjs/toolkit'

export const volunSlice = createSlice({
    name: 'volunslice',
    initialState: {
      value: []
    },
    reducers: {
      volunChange: (state, action) => {
        state.value = action.payload.value
      }
    }
  })
  // 每个 case reducer 函数会生成对应的 Action creators
  export const { volunChange } = volunSlice.actions
  
  export default volunSlice.reducer